import { createUser, getUsers } from '@lib/api'
import { usersKeys } from '@lib/keys'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useUsers = () => {
  return useQuery(usersKeys.all, () => getUsers())
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()

  return useMutation(createUser, {
    onSuccess: () => queryClient.invalidateQueries(usersKeys.all),
  })
}
